import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'empire-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.scss']
})
export class HomepageComponent implements OnInit {

  constructor() { }

  ngOnInit() {

  }

}
